// Lightweight bus so filtered list pages (Transactions, Customers, Merchants,
// AI Insights) can push their current "filtered total" to the global sidebar
// badge without prop-drilling or a context provider.
//
// Usage from a page:
//   import { notifySidebarCount } from '../../lib/sidebar-counts';
//   notifySidebarCount('transactions', pagination.total);
//
// The sidebar listens to `sidebar-count-update` and overrides its own
// platform-only count with the filtered total for the matching entity.

const EVENT_NAME = 'sidebar-count-update';

export function notifySidebarCount(entity, count) {
  if (typeof window === 'undefined') return;
  if (!entity || count === undefined || count === null) return;
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, { detail: { entity, count: Number(count) } })
  );
}

export function subscribeSidebarCounts(handler) {
  if (typeof window === 'undefined') return () => {};
  const fn = (e) => handler(e?.detail || {});
  window.addEventListener(EVENT_NAME, fn);
  return () => window.removeEventListener(EVENT_NAME, fn);
}
